var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 50,
    viewBox: "0 0 47 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M23.3437 49.3659C36.236 49.3659 46.6873 38.6567 46.6873 25.4464C46.6873 12.236 36.236 1.52686 23.3437 1.52686C10.4513 1.52686 0 12.236 0 25.4464C0 38.6567 10.4513 49.3659 23.3437 49.3659Z",
    fill: "url(#paint0_radial_1_32441)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18753 24.8681V9.29264C7.19611 7.03811 8.07395 4.87844 9.62977 3.28424C11.1856 1.69004 13.2933 0.790535 15.4935 0.781746H30.6289C31.7267 0.780277 32.814 1.00094 33.8283 1.43106C34.8427 1.86119 35.7642 2.49231 36.5399 3.28823C37.3156 4.08414 37.9304 5.02917 38.3488 6.06911C38.7673 7.10905 38.9812 8.22341 38.9783 9.34827V24.9238C38.9698 27.1783 38.0919 29.338 36.5361 30.9322C34.9803 32.5264 32.8726 33.4259 30.6723 33.4347H25.5367L22.8766 32.7671L20.5748 33.4347H15.4935C13.2839 33.4258 11.168 32.5187 9.61064 30.9124C8.05327 29.3062 7.18176 27.1323 7.18753 24.8681Z",
    fill: "url(#paint1_linear_1_32441)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2067 22.3428L29.9125 17.6368H25.5369V14.5885C25.5083 14.2382 25.5564 13.8858 25.6778 13.5571C25.7991 13.2284 25.9907 12.9316 26.2383 12.6885C26.486 12.4453 26.7836 12.262 27.1094 12.1518C27.4351 12.0417 27.7807 12.0076 28.121 12.0519H30.1188V8.04676C28.9448 7.84909 27.758 7.74124 26.5684 7.72412C22.942 7.72412 20.5642 9.94919 20.5642 14.0545V17.6368H16.5469V22.3428H20.575V33.3792H25.5369V22.3428H29.2067Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_32441",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.3437 25.4464) scale(0.542876 0.556268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#7373A2",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#D9D9E6",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_32441",
    x1: 36.492,
    y1: 3.34058,
    x2: 8.9649,
    y2: 30.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4676ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#436DE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3C55CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#302EA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B1E99"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.af675594f213e5205ee515b28337e895.svg";
export { ForwardRef as ReactComponent };